// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { basketSetFreebetBoolean, basketItemSetFreebetBoolean } from '../../actions/basket';
import useMergeProps from '../../hooks/useMergeProps';

import BasketFreebetsSwitch from './BasketFreebetsSwitch';
import makeBasketFreebetsSwitchPropsSelector from './BasketFreebetsSwitch.selector';

type BasketFreebetsSwitchContainerProps = {
  className?: string;
  itemId: number;
};

const BasketFreebetsSwitchContainer = (ownProps: BasketFreebetsSwitchContainerProps) => {
  const { itemId } = ownProps;

  const dispatch = useDispatch();

  const selectorProps = useMemo(() => ({ itemId }), [itemId]);
  const selector = useMemo(() => makeBasketFreebetsSwitchPropsSelector(), []);
  const selectedProps = useSelector((state) => selector(state, selectorProps));

  const { itemId: selectedItemId, isVisible } = selectedProps;

  const onToggle = useCallback(
    (isSelected) => {
      if (selectedItemId) {
        dispatch(
          basketItemSetFreebetBoolean({
            oddId: selectedItemId,
            freebetId: isSelected,
          }),
        );
      } else {
        dispatch(basketSetFreebetBoolean({ freebetId: isSelected }));
      }
    },
    [dispatch, selectedItemId],
  );

  const otherProps = useMemo(() => ({ onToggle }), [onToggle]);

  const enhancedProps = useMergeProps({ selectedProps, otherProps, ownProps });

  if (isVisible) {
    return <BasketFreebetsSwitch {...enhancedProps} />;
  }

  return null;
};

export default BasketFreebetsSwitchContainer;
